import { render } from "./SectionNavigationProfile.vue?vue&type=template&id=577e1dc4&scoped=true"
import script from "./SectionNavigationProfile.vue?vue&type=script&lang=js"
export * from "./SectionNavigationProfile.vue?vue&type=script&lang=js"

import "./SectionNavigationProfile.vue?vue&type=style&index=0&id=577e1dc4&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577e1dc4"]])

export default __exports__